import { Injectable } from '@angular/core';
import { ApiHttp } from 'app/providers';

@Injectable()
export class WeblogService {

    constructor(private apiHttp: ApiHttp) {
    }

    private prepareLoggingRequest(message: string, logLevel: number) {
        return {
            lg: [{
                l: logLevel,
                m: message,
                t: Date.now()
            }]
        };
    }

    private callWeblog(message: string, logLevel: number): Promise<any> {
        return this.apiHttp.post('api/Logging/WebLogging', this.prepareLoggingRequest(message, logLevel));
    }

    public trace(message: string): Promise<any> {
        return this.callWeblog(message, 1);
    }

    public debug(message: string): Promise<any> {
        return this.callWeblog(message, 1001);
    }

    public info(message: string): Promise<any> {
        return this.callWeblog(message, 2001);
    }

    public warn(message: string): Promise<any> {
        return this.callWeblog(message, 3001);
    }

    public error(message: string): Promise<any> {
        return this.callWeblog(message, 4001);
    }


}
